import React, { useEffect, useState } from "react";

import { FaSort, FaSortUp, FaSortDown, FaEye } from "react-icons/fa";
import moment from "jalali-moment";
import { personalPlanRequest } from "../../services/adminServices";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DateTimeRangeFilter from "units/components/DateTimeRangeFilter";
import MsgModal from "./MsgModal"
export default function PersonalPlanRequestTable() {
    const [transactions, setTransactions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [searchQuery, setSearchQuery] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [originalTransactions, setOriginalTransactions] = useState([]); // داده‌های اصلی تراکنش‌ها
    const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
    const [usernameModalData, setUsernameModalData] = useState(null);
    const accessToken = useSelector((state) => state.auth.accessToken);
    useEffect(() => {
        const planRequest = async () => {
            try {
                const res = await personalPlanRequest(accessToken);

                if (res?.ok) {
                    const sortedData = res?.data.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    );
                    setTransactions(
                        sortedData.map((item) => ({
                            ...item,
                            date: moment.utc(item.createdAt)
                            .local()
                            .locale('fa')
                            .format("jYYYY/jMM/jDD"),
                            time: moment.utc(item.createdAt)
                            .local()
                            .locale('fa')
                            .format("HH:mm")
                        }))
                    );
                    setOriginalTransactions(
                        res?.data.map((item) => ({
                            ...item,
                            date:moment.utc(item.createdAt)
                            .local()
                            .locale('fa')
                            .format("jYYYY/jMM/jDD"),
                            time: moment.utc(item.createdAt)
                            .local()
                            .locale('fa')
                            .format("HH:mm"),
                        }))
                    );
                }
            } catch (error) {
                console.log("خطا در دریافت اطلاعات:", error);
            }
        };

        planRequest();
    }, [accessToken]);
    const openUsernameModal = (message) => {
        if (!message) return;
        setUsernameModalData(message); // ذخیره داده‌های مربوط به username
        setIsUsernameModalOpen(true); // باز کردن مودال
    };

    const closeUsernameModal = () => {
        setIsUsernameModalOpen(false); // بستن مودال
        setUsernameModalData(null); // پاک کردن داده‌ها
    };
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };

    const sortedTransactions = [...transactions].sort((a, b) => {
        if (sortConfig.key) {
            if (sortConfig.key === "date") {
                const dateA = `${a.date} ${a.time}`;
                const dateB = `${b.date} ${b.time}`;
                return sortConfig.direction === "asc"
                    ? dateA.localeCompare(dateB, "fa", { numeric: true })
                    : dateB.localeCompare(dateA, "fa", { numeric: true });
            } else {
                return sortConfig.direction === "asc"
                    ? a[sortConfig.key].localeCompare(b[sortConfig.key])
                    : b[sortConfig.key].localeCompare(a[sortConfig.key]);
            }
        }
        return 0;
    });
    const filteredTransactions = sortedTransactions.filter((transaction) => {
        const isMatch =
            transaction.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            transaction.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
            transaction.phone.toLowerCase().includes(searchQuery.toLowerCase());

        return isMatch;
    });

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);




    const totalPages = Math.ceil(transactions.length / rowsPerPage);
    const paginatedTransactions = filteredTransactions.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    //   const handleDateFilter = (fromDate = null, toDate = null) => {
    //     if (!fromDate && !toDate) {
    //       setTransactions(originalTransactions);
    //       return;
    //     }

    //     const from = moment(
    //       convertPersianToLatinNumbers(
    //         `${fromDate.year}/${fromDate.month}/${fromDate.day}`
    //       ),
    //       "jYYYY/jM/jD"
    //     );
    //     const to = moment(
    //       convertPersianToLatinNumbers(
    //         `${toDate.year}/${toDate.month}/${toDate.day}`
    //       ),
    //       "jYYYY/jM/jD"
    //     );

    //     setTransactions(
    //       originalTransactions.filter((transaction) => {
    //         const transactionDate = moment(
    //           convertPersianToLatinNumbers(transaction.date),
    //           "jYYYY/jMM/jDD"
    //         );
    //         return transactionDate.isBetween(from, to, "day", "[]");
    //       })
    //     );
    //     setCurrentPage(1);
    //   };

    const convertPersianToLatinNumbers = (str) => {
        const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        const latinNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        return str
            .split("")
            .map((char) => {
                const index = persianNumbers.indexOf(char);
                return index !== -1 ? latinNumbers[index] : char;
            })
            .join("");
    };
    const handleDateFilter = ({ startDate, endDate }) => {
        if (!startDate || !endDate) {
            // اگر فیلتر پاک شد، داده‌ها به حالت اولیه برگرده
            setTransactions(originalTransactions);
            setCurrentPage(1);
            return;
        }

        // const filtered = originalTransactions.filter((item) => {
        //     const itemDate = new Date(item.createdAt);
        //     return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
        // });
        // const filtered = originalTransactions.filter((item) => {
        //     const itemTime = new Date(item.createdAt).getTime();
        //     const startTime = new Date(startDate).getTime();
        //     const endTime = new Date(endDate).getTime();
        //     return itemTime >= startTime && itemTime <= endTime;
        // });
        const filtered = originalTransactions.filter((item) => {
            const itemTime = moment(item.createdAt);
            const start = moment(startDate);
            const end = moment(endDate);
        
            return itemTime.isSameOrAfter(start) && itemTime.isSameOrBefore(end);
        });
        
        
        setTransactions(filtered);
        setCurrentPage(1);
    };

    useEffect(() => {
        const startDate = localStorage.getItem("startDate");
        const endDate = localStorage.getItem("endDate");
        if (originalTransactions.length && startDate && endDate) {
            handleDateFilter({ startDate, endDate });
        }
    }, [originalTransactions]);

    const handleClearFilter = () => {
        // پاک کردن localStorage
        localStorage.removeItem("startDate");
        localStorage.removeItem("endDate");

        // ریست کردن جدول
        setTransactions(originalTransactions);
        setCurrentPage(1);
    };
 
    
    return (
        <div className="col-span-12 xl:col-span-6 xl:p-6 min-h-screen rtl shadow-sm">
            <div className="flex flex-wrap justify-start items-center gap-4 w-full max-w-[850px] m-auto mt-5 mb-4">
                <div className="flex items-center  space-x-1  ">
                    <label className="text-[#1b4747] whitespace-nowrap font-bold ">جستجو:</label>
                    <input
                        type="text"
                        placeholder="جستجو..."
                        className="flex-grow py-2 border rounded px-3 w-full"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <DateTimeRangeFilter
                    onApplyFilter={handleDateFilter}
                    onClearFilter={handleClearFilter}
                />
            </div>
            <div className="overflow-x-auto">
                <table className=" border-none shadow-md mt-1 m-auto rtl w-full max-w-[850px] overflow-x-auto">
                    <thead className="bg-gray-100 text-gray-700 text-center rounded-xl ">
                        <tr>
                            <th className="p-3 ">{" "}</th>
                            <th className="p-3 w-1/5">نام و نام خانوادگی</th>
                            <th
                                className="p-3 cursor-pointer w-1/5"
                                onClick={() => handleSort("date")}
                            >
                                تاریخ ثبت{" "}
                                {sortConfig.key === "date" ? (
                                    sortConfig.direction === "asc" ? (
                                        <FaSortUp />
                                    ) : (
                                        <FaSortDown />
                                    )
                                ) : (
                                    <FaSort />
                                )}
                            </th>
                            <th
                                className="p-1 cursor-pointer w-1/6"
                            >
                                ایمیل
                            </th>
                            <th className="p-3 w-2/5">تلفن</th>
                            <th className="p-3 w-2/5">توضیحات</th>
                        </tr>
                    </thead>
                    <div>

                    </div>
                    <tbody className="bg-white divide-y divide-gray-300">
                        {paginatedTransactions.map((row, index) => (
                            <tr key={index} className="hover:bg-gray-100 transition">

                                <td
                                    className="p-1  text-center"
                                >
                                    <div className="p-1 bg-[#ffce4c] rounded-md text-center">
                                        {index + 1}
                                    </div>

                                </td>
                                <td
                                    className="p-1 sm:p-3 text-center "
                                >
                                    {row.name}
                                </td>
                                <td className="p-1 sm:p-3 text-center">
                                    {row.date}
                                    <br />
                                    {row.time}
                                </td>
                                <td className="p-1 sm:p-3 text-center ">
                                    {row.email}
                                </td>
                                <td className="p-1 sm:p-3 text-center">
                                    {row.phone}
                                </td>
                                <td className="p-1 sm:p-3 text-center cursor-pointer"
                                    onClick={() => row.message && openUsernameModal(row.message)}
                                >
                                    {/* {row.message} */}
                                    <FaEye
                                        className="inline-block cursor-pointer text-[#1b4747] w-10 "
                                        title={"نمایش "}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-between items-center mt-6 w-full max-w-[850px] m-auto">
                <div className="flex items-center justify-between space-x-2 ">
                    <label className="whitespace-nowrap text-gray-700">نمایش:</label>
                    <select
                        value={rowsPerPage}
                        onChange={(e) => setRowsPerPage(Number(e.target.value))}
                        className="py-2 border rounded-lg px-4 text-gray-700 hover:ring-2 hover:ring-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 w-16"
                    >
                        {[5, 10, 15].map((num) => (
                            <option key={num} value={num}>
                                {num}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="text-center text-sm text-gray-600 ">
                    نمایش {paginatedTransactions.length} از {filteredTransactions.length}{" "}
                    (کل: {originalTransactions.length})
                </div>

                <div className="flex items-center space-x-3 mr-2">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => prev - 1)}
                        className="p-2 border rounded-lg bg-gray-200 hover:bg-gray-300 disabled:bg-gray-200 transition duration-200"
                    >
                        قبلی
                    </button>
                    <span className="text-gray-700 px-2 text-center">
                        {" "}
                        {currentPage}{" "}
                    </span>
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((prev) => prev + 1)}
                        className="p-2 border rounded-lg bg-gray-200 hover:bg-gray-300 disabled:bg-gray-200 transition duration-200"
                    >
                        بعدی
                    </button>
                </div>
            </div>
            <MsgModal
                isOpen={isUsernameModalOpen}
                closeModal={closeUsernameModal}
                modalData={usernameModalData}
            />


        </div>
    );
}
